if (!customElements.get('sticky-buy-bar')) {
  class StickyBuyBar extends HTMLElement {
    connectedCallback() {
      this.target = document.querySelector(this.dataset.watch);
      this.button = this.querySelector('[data-sticky-add]');
      this.price = this.querySelector('[data-sticky-price]');
      if (!this.target) return;

      this.frame = null;
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          // Only once the form is fully above the screen — not before reaching it.
          const formAbove = this.target.getBoundingClientRect().bottom < 0;

          // Hide when the footer comes into view
          const footer = document.querySelector('footer');
          const footerVisible = footer ? (footer.getBoundingClientRect().top < window.innerHeight) : false;

          this.toggle(formAbove && !footerVisible);
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();

      this.onVariantChange = (event) => {
        if (event.detail.sectionId !== this.dataset.sectionId) return;
        this.update(event.detail.variant);
      };
      document.addEventListener('product:variant-change', this.onVariantChange);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      cancelAnimationFrame(this.frame);
      document.removeEventListener('product:variant-change', this.onVariantChange);
      document.documentElement.classList.remove('has-sticky-buy-bar');
    }

    toggle(visible) {
      if (visible === this.visible) return;
      this.visible = visible;
      this.classList.toggle('is-visible', visible);
      // Hidden bar is unreachable by keyboard and screen readers.
      this.inert = !visible;
      // Only reserve space when the bar is actually shown on this device
      // ("Show on: Mobile only / Desktop only" hides it with CSS).
      const displayed = getComputedStyle(this).display !== 'none';
      document.documentElement.classList.toggle('has-sticky-buy-bar', visible && displayed);
    }

    update(variant) {
      const isSold = variant ? Boolean(variant.is_sold || !variant.available) : false;
      if (this.price) {
        this.price.hidden = isSold;
        if (isSold) {
          this.price.classList.add('hidden');
          this.price.style.display = 'none';
        } else {
          this.price.classList.remove('hidden');
          this.price.style.display = '';
          if (variant) this.price.textContent = variant.price;
        }
      }
      if (!this.button) return;

      const available = Boolean(variant && variant.available && !isSold);
      this.button.disabled = !available;
      this.button.classList.toggle('is-sold', isSold);
      if (!variant) this.button.textContent = this.button.dataset.textUnavailable;
      else if (isSold) this.button.textContent = this.button.dataset.textSoldOut;
      else this.button.textContent = this.button.dataset.textAdd;
    }
  }

  customElements.define('sticky-buy-bar', StickyBuyBar);
}
